var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};
export default function mergeRefs(refA, refB, refC) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  var c = toFnRef(refC);
  return function (value) {
    if (typeof a === 'function') a(value);
    if (typeof b === 'function') b(value);
    if (typeof c === 'function') c(value);
  };
}